import type { Route } from '@/types';
import { getRouteName, getSortedAlerts } from '../../utils/routeHelpers';

interface RouteCardBackProps {
  route: Route;
}

export function RouteCardBack({ route }: RouteCardBackProps) {
  const routeName = getRouteName(route);
  const alerts = getSortedAlerts(route);

  return (
    <div className="flip-card-back">
      <div className="back-content">
        <h2 className="back-header">
          <span className="back-content-alert-icon">⚠️</span>
          {routeName} Alerts
        </h2>
        <ul>
          {alerts.map((alert, index) => (
            <li
              key={index}
              className={`alert-details alert-${alert.severity}`}
            >
              <p className="alert-title">{alert.title}</p>
            </li>
          ))}
        </ul>
        {alerts.length === 0 && <p>No active alerts</p>}
      </div>
    </div>
  );
}
